import { Link } from "react-router-dom";

const categories = [
  {
    to: "/category/movie",
    title: "电影频道",
    desc: "院线新片 · 经典佳作 · 类型精选",
    icon: "ri-movie-2-line",
  },
  {
    to: "/category/tv",
    title: "电视剧频道",
    desc: "热播剧集 · 口碑好剧 · 追剧必备",
    icon: "ri-live-line",
  },
];

export default function CategoryQuickLinks() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      {categories.map((category, index) => (
        <Link
          key={category.to}
          to={category.to}
          className={`group flex items-center gap-4 rounded-lg border p-5 transition-colors ${
            index === 0
              ? "border-background-200 bg-background-50 hover:border-primary-300"
              : "border-background-200 bg-background-50 hover:border-secondary-300"
          }`}
        >
          <span
            className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-md ${
              index === 0
                ? "bg-primary-600 text-background-50"
                : "bg-secondary-500 text-background-50"
            }`}
          >
            <i className={`${category.icon} text-2xl`}></i>
          </span>
          <div className="min-w-0">
            <h3 className="font-heading text-base font-semibold text-foreground-900 transition-colors group-hover:text-secondary-600">
              {category.title}
            </h3>
            <p className="mt-1 truncate text-sm text-foreground-500">{category.desc}</p>
          </div>
          <i className="ri-arrow-right-line ml-auto text-xl text-foreground-300 transition-colors group-hover:text-secondary-500"></i>
        </Link>
      ))}
    </div>
  );
}